import React, { useCallback } from 'react';
import { useBoolean } from 'ahooks';
import { Tooltip, Popover } from '@mantine/core';
import { NumberInputGroup } from '@shakkerai/pro-components';

export const PopoverSlider = React.memo(
  ({ name, value, onChange, min, max, label, tooltip, trigger = 'hover', children }) => {
    const [opened, actions] = useBoolean(false);

    const handleClick = useCallback(() => {
      trigger === 'click' && actions.toggle();
    }, [actions, trigger]);

    const handleMousEnter = useCallback(() => {
      trigger === 'hover' && actions.setTrue();
    }, [actions, trigger]);

    const handleMouseLeave = useCallback(() => {
      trigger === 'hover' && actions.setFalse();
    }, [actions, trigger]);

    return (
      <Popover
        width={180}
        opened={opened}
        position="bottom"
        radius={4}
        shadow="md"
        withinPortal={true}
        arrowOffset={40}
      >
        <Popover.Target>
          <Tooltip withArrow disabled={opened || !tooltip} position="bottom-right" className="scale-90" label={tooltip}>
            <div
              onClick={handleClick}
              onMouseEnter={handleMousEnter}
              onMouseLeave={handleMouseLeave}
              className="flex h-8 items-center"
            >
              {children}
            </div>
          </Tooltip>
        </Popover.Target>
        <Popover.Dropdown
          onMouseEnter={handleMousEnter}
          onMouseLeave={handleMouseLeave}
          className="flex flex-col items-stretch -mt-2.5 p-0 bg-transparent border-none"
        >
          <div className="relative self-center z-[1] w-2 h-2 bg-white rounded-sm rotate-45 -translate-x-1.5 translate-y-1.5"></div>
          <div className="flex items-center p-1 pl-2 bg-white shadow-light rounded">
            <span className="text-xs text-[#222] font-medium mr-3">{label}</span>
            <NumberInputGroup name={name} min={min} max={max} value={value} onChange={onChange} />
          </div>
        </Popover.Dropdown>
      </Popover>
    );
  },
);
